import setReduxAction from '../../../redux/actions/set'
import { START_WORKOUT_ACTION, START_WORKOUT_PATH } from '../../constants'

function updateCurrentWorkoutExerciseIndexStartWorkoutAction (index) {
  return setReduxAction({
    type: START_WORKOUT_ACTION.UPDATE_CURRENT_WORKOUT_EXERCISE_INDEX,
    payload: {
      path: START_WORKOUT_PATH.CURRENT_WORKOUT_EXERCISE_INDEX,
      value: index >= 0
        ? index
        : 0
    }
  })
}

export { updateCurrentWorkoutExerciseIndexStartWorkoutAction }
